import React, { useState } from "react";
import DoughnutChart from "./chart";
import QuizModal from "./Quizmodal";
import { useDispatch, useSelector } from "react-redux";
import { Submitquiz, View_Answer } from "../redux/authslice";
import confetti from "canvas-confetti";
import { useNavigate } from "react-router-dom";

const QuizImg = ({
  QuizzData,
  currentQuestionIndex,
  userAnswers,
  hasNavigatedLastQuestion,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { viewData } = useSelector((state) => state.counter);

  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    navigate("/quizgenerator");
    localStorage.removeItem("id");
  };

  const handleShow = () => {
    confetti({
      particleCount: 150,
      spread: 80,
      origin: { y: 0.7 },
      zIndex: 9999,
    });
    setShow(true);
  };
  const handlesubmit = () => {
    const q_id = localStorage.getItem("id");
    handleShow();
    dispatch(Submitquiz({ id: q_id, userAnswers, dispatch }));
    // dispatch(View_Answer({ id: q_id, navigate, dispatch }));
  };

  const isLastQuestion = currentQuestionIndex === QuizzData?.length - 1;
  const isQuizComplete = userAnswers?.length === QuizzData?.length;
  const showSubmitButton =
    isLastQuestion && hasNavigatedLastQuestion && isQuizComplete;

  return (
    <div className="col-lg-4">
      <div className="all-right-box">
        <div className="question-right">
          <p className="qus-right">Questions remaining</p>
          <DoughnutChart
            QuizzData={QuizzData}
            currentQuestionIndex={currentQuestionIndex}
          />
        </div>
        <div className="quiz-no">
          <ul className="quiz-no-ul">
            {QuizzData?.map((ele, indx) => (
              <li key={indx}>
                <a
                  className={
                    window.location.pathname === "/quizquestion"
                      ? currentQuestionIndex === indx
                        ? ele?.is_right
                          ? "color-green"
                          : "color-red"
                        : currentQuestionIndex > indx
                        ? ele?.is_right
                          ? "color-green"
                          : "color-red"
                        : ""
                      : currentQuestionIndex === indx
                      ? "color-quiz-2"
                      : currentQuestionIndex > indx
                      ? "color-quiz-1"
                      : ""
                  }
                >
                  {indx + 1}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {window.location.pathname === "/quizquestion" ? (
          <button
            className="btn submit-quiz-btn-primary"
            onClick={() => navigate("/quizgenerator")}
          >
            Generate quiz
          </button>
        ) : (
          showSubmitButton && (
            <button
              className="btn submit-quiz-btn-primary"
              onClick={handlesubmit}
              disabled={!isQuizComplete}
            >
              Submit quiz
            </button>
          )
        )}
      </div>
      <QuizModal
        show={show}
        handleClose={handleClose}
        QuizzData={QuizzData}
        currentQuestionIndex={currentQuestionIndex}
        viewData={viewData}
      />
    </div>
  );
};

export default QuizImg;
